import 'twin.macro';
import 'styled-components/macro';

import { Link } from 'react-router-dom';

import { Button } from 'component-lib/atoms/button/Button';

export const AccountActions = (props: React.HTMLProps<HTMLDivElement>) => (
  <div {...props}>
    <Link tw="mr-half" to="/login">
      <Button>Login</Button>
    </Link>
    <Link to="/signup">
      <Button variant="primary">Create account</Button>
    </Link>
  </div>
);
